const LOGOUT_BROADCAST_KEY = 'shw-logout-broadcast'

/**
 * Broadcasts a logout event to all other tabs/windows.
 * Other tabs will reload when they receive this event.
 * Call this when the user clicks a logout link.
 */
export function broadcastLogout(): void {
  try {
    globalThis.localStorage.setItem(LOGOUT_BROADCAST_KEY, Date.now().toString())
  } catch {
    // localStorage may be unavailable in some contexts (e.g., private browsing)
  }
}

/**
 * Sets up a listener for logout broadcasts from other tabs.
 * When a logout is detected, the page will reload.
 * Returns a cleanup function to remove the listener.
 */
export function listenForLogoutBroadcast(): () => void {
  const handleStorageChange = (event: StorageEvent) => {
    if (event.key === LOGOUT_BROADCAST_KEY && event.newValue != null) {
      globalThis.location.reload()
    }
  }

  globalThis.addEventListener('storage', handleStorageChange)

  return () => {
    globalThis.removeEventListener('storage', handleStorageChange)
  }
}
